/**
 * Preferenza locale della sidebar master (pin "menu bloccato aperto").
 * Lettura tollerante: valore assente, corrotto o storage non disponibile
 * (modalità privata, SSR) → default `false`, mai eccezioni.
 */
export const MASTER_SIDEBAR_PINNED_STORAGE_KEY = 'master-sidebar-pinned';

export function readSidebarPinnedPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(MASTER_SIDEBAR_PINNED_STORAGE_KEY);
    if (raw === null) return false;
    const parsed: unknown = JSON.parse(raw);
    return parsed === true;
  } catch {
    return false;
  }
}

export function writeSidebarPinnedPreference(pinned: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(MASTER_SIDEBAR_PINNED_STORAGE_KEY, JSON.stringify(pinned));
  } catch {
    // Storage pieno o bloccato: la scelta vale per la sessione corrente.
  }
}
